import React, { useEffect, useState } from 'react';

type WallpaperSlide = {
  src: string;
  alt: string;
};

/** Full-bleed campus wallpapers — cinematic, warm, academic. */
const SLIDES: WallpaperSlide[] = [
  {
    src: 'https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=2200&q=82',
    alt: 'University campus building at dusk',
  },
  {
    src: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=2200&q=82',
    alt: 'Campus courtyard and academic halls',
  },
  {
    src: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=2200&q=82',
    alt: 'Students learning in a bright classroom',
  },
  {
    src: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=2200&q=82',
    alt: 'Library shelves with books',
  },
  {
    src: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=2200&q=82',
    alt: 'Classroom desks ready for the day',
  },
];

const INTERVAL_MS = 7500;

/** Cycling full-bleed wallpaper for the landing hero. */
export function HeroWallpaper() {
  const [active, setActive] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReduceMotion(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (reduceMotion || SLIDES.length < 2) return;
    const id = window.setInterval(() => {
      setActive((i) => (i + 1) % SLIDES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [reduceMotion]);

  return (
    <div className="hero-wallpaper" aria-hidden>
      {SLIDES.map((slide, i) => (
        <div
          key={slide.src}
          className={`hero-wallpaper__slide${i === active ? ' is-active' : ''}${
            reduceMotion ? ' hero-wallpaper__slide--static' : ''
          }`}
        >
          <img
            className="hero-wallpaper__img"
            src={slide.src}
            alt=""
            decoding="async"
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}
      <div className="hero-wallpaper__scrim" />
      <div className="hero-wallpaper__vignette" />
      <div className="hero-wallpaper__grain" />
      <div className="hero-wallpaper__progress">
        {SLIDES.map((_, i) => (
          <span
            key={i}
            className={`hero-wallpaper__tick${i === active ? ' is-active' : ''}${
              reduceMotion ? ' is-static' : ''
            }`}
          />
        ))}
      </div>
    </div>
  );
}
